export interface InjectPlanLocationRequest {
    planId: string;
    locationId: string;
    day: number;
    productIds: string[];
    locationGroupId?:string | null;
    isLocationGroup?:boolean;
  }